import React, { useState } from 'react';
import { Paper, ButtonBase, Typography, Collapse } from '@material-ui/core';
import { ChevronUp, ChevronDown } from 'react-feather';
import styled from '../styled';

const StyledPaper = styled(Paper)`
  background: #22262b;
  box-shadow: 0px 1px 5px rgba(0, 0, 0, 0.25);
`;

const ChevonWrapper = styled('div')`
  display: flex;
  align-items: center;
  justify-content: center;
  background-color: ${(p) => p.theme.palette.grey[600]};
  height: 36px;
  width: 36px;
  border-radius: 100%;
`;

const FaqTitle = styled<typeof ButtonBase, { open: boolean }>(ButtonBase)`
  display: grid;
  grid-template-columns: 1fr max-content;
  grid-column-gap: 12px;
  width: 100%;
  text-align: left;
  padding: ${(p) => p.theme.spacing(3)}px ${(p) => p.theme.spacing(4)}px;
  font-size: 18px;
  line-height: 24px;
  font-family: Lato;
  font-weight: 600;
  overflow: hidden;
  ${(p) => !p.open && `border-bottom: 1px solid #191c20;`}

  &:hover {
    background-color: ${(p) => p.theme.palette.grey[600]};
    border-radius: ${(p) => p.theme.shape.borderRadius}px;
  }
`;

const FaqBody = styled('div')`
  padding: ${(p) => p.theme.spacing(3)}px ${(p) => p.theme.spacing(4)}px;
  border-bottom: 1px solid #191c20;
  font-size: 18px;
  line-height: 32px;
  color: ${(p) => p.theme.palette.grey[300]};

  a {
    border-bottom: 1px solid;
  }
`;

export const Faq = ({
  title,
  content,
  open,
  onClick
}: {
  title: React.ReactNode;
  content: React.ReactNode;
  open: boolean;
  onClick: () => any;
}) => {
  return (
    <div>
      <FaqTitle
        open={open}
        onClick={() => {
          onClick();
        }}
      >
        <div>{title}</div>
        <ChevonWrapper>
          {open ? <ChevronUp size={22} /> : <ChevronDown size={22} />}
        </ChevonWrapper>
      </FaqTitle>
      <Collapse in={open}>
        <FaqBody>{content}</FaqBody>
      </Collapse>
    </div>
  );
};

const Group = styled('div')`
  max-width: 800px;
  text-align: left;
  margin: ${(p) => p.theme.spacing(2)}px auto ${(p) => p.theme.spacing(2)}px;
`;

export const FaqGroup = ({
  title,
  faqs
}: {
  title?: React.ReactNode;
  faqs: { title: string; content: React.ReactNode }[];
}) => {
  const [open, setOpen] = useState<number | null>(null);

  return (
    <Group>
      {title && (
        <Typography
          variant="body1"
          style={{ fontWeight: 700, padding: '24px', textAlign: 'center' }}
        >
          {title}
        </Typography>
      )}
      <StyledPaper>
        {faqs.map((f, i) => (
          <Faq
            title={f.title}
            content={f.content}
            key={f.title}
            open={i === open}
            onClick={() => {
              if (i === open) {
                setOpen(null);
                return;
              }
              setOpen(i);
            }}
          />
        ))}
      </StyledPaper>
    </Group>
  );
};
